import { render } from "./TheDashboardNavbar.vue?vue&type=template&id=5e858d0f&scoped=true"
import script from "./TheDashboardNavbar.vue?vue&type=script&lang=js"
export * from "./TheDashboardNavbar.vue?vue&type=script&lang=js"

import "./TheDashboardNavbar.vue?vue&type=style&index=0&id=5e858d0f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e858d0f"]])

export default __exports__